/**
 * WEHAGO Conference 룸 커맨드 상수
 * 기존 ConferenceConnector.js에서 export하던 커맨드 이름들을 별도 파일로 분리.
 */
export const CONFERENCE_COMMANDS = {
  // 위하고 사용자 정보 (닉네임 등) 공유
  WEHAGO_ID: 'wehagoid',

  // 스케치 모드 시작/종료 (원본: SET_DRAWING_IS_SHARE)
  SET_DRAWING_IS_SHARE: 'SET_DRAWING_IS_SHARE',

  // 그리기/스케치모드 데이터 (원본: UPDATE_DOCUMENT_DATA, canvasType:'sketch')
  UPDATE_DOCUMENT_DATA: 'UPDATE_DOCUMENT_DATA',

  // 캔버스 지우기 (원본: CLEAR_DRAWING_CANVAS)
  CLEAR_DRAWING_CANVAS: 'CLEAR_DRAWING_CANVAS',

  // 문서 공유
  SET_DOCUMENT_SHARE_IS_OPEN: 'SET_DOCUMENT_SHARE_IS_OPEN',
  SET_DOCUMENT_SHARE_IS_CLOSE: 'SET_DOCUMENT_SHARE_IS_CLOSE',

  // 문서 공유 페이지 변경 (원본: SET_DOCUMENT_PAGE)
  SET_DOCUMENT_PAGE: 'SET_DOCUMENT_PAGE',

  // 문서 공유 캔버스 지우기 (원본: CLEAR_DOCUMENT_CANVAS)
  CLEAR_DOCUMENT_CANVAS: 'CLEAR_DOCUMENT_CANVAS',

  // 문서공유 특정 타겟 (늦은 참가자용, 원본: DOCUMENT_SHARE_TARGET)
  DOCUMENT_SHARE_TARGET: 'DOCUMENT_SHARE_TARGET',

  // 드로잉 특정 타겟 (늦은 참가자용, 원본: DRAWING_SHARE_TARGET)
  DRAWING_SHARE_TARGET: 'DRAWING_SHARE_TARGET',

  // 발언권
  REQUEST_FLOOR: 'REQUEST_FLOOR',
  GRANT_FLOOR: 'GRANT_FLOOR',
  GRANT_FLOOR_TARGET: 'GRANT_FLOOR_TARGET',
  STOP_FLOOR: 'STOP_FLOOR',
  SET_GRANT_FLOOR_USER_LIST: 'SET_GRANT_FLOOR_USER_LIST',

  // 화면 공유
  IS_DESKTOP_SHARED: 'IS_DESKTOP_SHARED',

  // 번역/음성인식 모드
  IS_TRANSLATION_MODE: 'IS_TRANSLATION_MODE',

  // 참여자 제어
  CHANGE_PARTICIPANT_MUTE_VIDEO: 'CHANGE_PARTICIPANT_MUTE_VIDEO',

  // 중복 접속 정리
  CLEAR_GHOST_USER: 'CLEAR_GHOST_USER',
  SET_DELETE_SAME_PARTICIPANT: 'SET_DELETE_SAME_PARTICIPANT',

  // STT 마이크 권한
  SET_VOICE_NOTE_MIC_GRANT_LIST: 'SET_VOICE_NOTE_MIC_GRANT_LIST',

  // 녹화 요청 (방장 → 참여자)
  REQUEST_START_RECORDING: 'REQUEST_START_RECORDING',
  REQUEST_STOP_RECORDING: 'REQUEST_STOP_RECORDING',

  // STT 버튼 상태
  CHANGE_SPEECH_BUTTON: 'CHANGE_SPEECH_BUTTON',

  // 마스터(호스트) 관련
  CHANGE_MASTER_USER_LIST: 'CHANGE_MASTER_USER_LIST',
  GET_REMAINING_MASTER: 'GET_REMAINING_MASTER',
  INIT_ROOM_PUBLIC_MODE: 'INIT_ROOM_PUBLIC_MODE',
  CHANGE_MASTER_MIC_CONTROL: 'CHANGE_MASTER_MIC_CONTROL',
  CHANGE_MASTER_VIDEO_SEQ: 'CHANGE_MASTER_VIDEO_SEQ',

  // 마스터 목록 동기화 (토큰 없는 비회원에게 마스터 목록 전파)
  SYNC_MASTER_USERS: 'SYNC_MASTER_USERS',

  // 녹화 데이터 (참여자 간 커맨드)
  REQUEST_RECORD_USER: 'REQUEST_RECORD_USER',
  UPDATE_RECORD_DATA: 'UPDATE_RECORD_DATA',

  // 리액션 이모지
  ENDPOINT_MEET_REACTION: 'ENDPOINT_MEET_REACTION',

  // 마스터 화면 고정 브로드캐스트 (v1 UPDATE_MASTER_PIN_FIXED)
  UPDATE_MASTER_PIN_FIXED: 'UPDATE_MASTER_PIN_FIXED',

  // 방 생성자(최초 마스터)의 화면 상태 브로드캐스트 — recorder(Jibri) 전용 구독.
  SYNC_CREATOR_SCREEN: 'SYNC_CREATOR_SCREEN',

  // 마스터 → 참여자 미디어 제어 (모두 끄기, 켜기 요청, 개별 끄기/요청)
  MASTER_MEDIA_CONTROL: 'MASTER_MEDIA_CONTROL',

  // 번역 토글 상태 브로드캐스트 (참여자 → 전체)
  TRANSLATION_TOGGLE_STATUS: 'TRANSLATION_TOGGLE_STATUS',

  // 회의방 정보(이름/공개여부/암호/번역설정/연결회의/설명/키워드 등) 변경 알림 (마스터 → 전체)
  // 수신 측은 getRoomEditInfo 재조회로 로컬 상태를 갱신한다.
  ROOM_INFO_UPDATED: 'ROOM_INFO_UPDATED',

  // 초대된 참석자 목록 변경 알림 (초대 완료 시 → 전체)
  // 수신 측은 getInvitedParticipantList 재조회로 초대 목록을 갱신한다.
  INVITE_LIST_UPDATED: 'INVITE_LIST_UPDATED',

  // 마스터가 모든 참여자에게 회의 종료 알림
  END_MEETING_FOR_ALL: 'END_MEETING_FOR_ALL',
} as const;

export type ConferenceCommand = (typeof CONFERENCE_COMMANDS)[keyof typeof CONFERENCE_COMMANDS];
